import {
  OMS_BUSINESS_TOOLS_SPEND_BY_DEPARTMENT_PATH,
  OMS_BUSINESS_TOOLS_SPEND_BY_ITEMS_PATH,
  OMS_BUSINESS_TOOLS_SPEND_BY_JOB_NAME_PATH,
  OMS_BUSINESS_TOOLS_SPEND_BY_QUANTITY_PATH,
  OMS_BUSINESS_TOOLS_SPEND_BY_STORE_PATH,
} from '../../constants/paths';
import { IBusinessToolsRequest } from '../../models/business-tools';
import { apiBase } from '../axios-client';
import { getUserId } from '../../utils/user';

const userId = getUserId() ?? '';

export const TopSpendByJobNameAPI = (requestData: IBusinessToolsRequest) => {
  return apiBase.post(
    OMS_BUSINESS_TOOLS_SPEND_BY_JOB_NAME_PATH(userId),
    requestData,
  );
};

export const TopSpendByStoreAPI = (requestData: IBusinessToolsRequest) => {
  return apiBase.post(
    OMS_BUSINESS_TOOLS_SPEND_BY_STORE_PATH(userId),
    requestData,
  );
};

export const TopSpendByDepartmentAPI = (requestData: IBusinessToolsRequest) => {
  return apiBase.post(
    OMS_BUSINESS_TOOLS_SPEND_BY_DEPARTMENT_PATH(userId),
    requestData,
  );
};

export const TopSpendByItemSpendAPI = (requestData: IBusinessToolsRequest) => {
  return apiBase.post(
    OMS_BUSINESS_TOOLS_SPEND_BY_ITEMS_PATH(userId),
    requestData,
  );
};

export const TopSpendByItemQuantityAPI = (
  requestData: IBusinessToolsRequest,
) => {
  return apiBase.post(
    OMS_BUSINESS_TOOLS_SPEND_BY_QUANTITY_PATH(userId),
    requestData,
  );
};
